










import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'VideoItem',
  props: {
    type: String,
    link: String,
    name: String,
    poster: String,
    filename: String,
  },
})
